import React from 'react';

type ExperienceContextValue = string | undefined;

const defaultExperienceContextValue: ExperienceContextValue = undefined;

export const ExperienceContext: React.Context<ExperienceContextValue> =
	React.createContext<ExperienceContextValue>(defaultExperienceContextValue);
